/**
 * Estimates the token volume represented by visible streamed text.
 *
 * Provider usage is not always available in live UI events (AI-SDK v5
 * reasoning parts don't carry per-part token counts), so we fall back to
 * the ~4-characters-per-token display heuristic. Whitespace is collapsed
 * first so long stretches of indentation or blank lines don't inflate
 * the count while streaming.
 */
export function estimateDisplayTokenCount(text: string): number {
  const compactText = text.trim().replace(/\s+/g, " ");
  if (!compactText) return 0;
  return Math.max(1, Math.ceil(compactText.length / 4));
}
